import React from 'react';

interface LogoProps {
  className?: string;
  size?: 'small' | 'default' | 'large';
  showText?: boolean;
}

export default function Logo({ className = '', size = 'default', showText = true }: LogoProps) {
  const sizeClasses = {
    small: 'h-8',
    default: 'h-12',
    large: 'h-16'
  };

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <div className="flex items-center space-x-3">
        <img 
          src="/logo.svg" 
          alt="Allo Réparateur Logo" 
          className={sizeClasses[size]}
        />
        {showText && (
          <div className={`font-bold text-primary ${
            size === 'small' ? 'text-xl' : size === 'large' ? 'text-4xl' : 'text-2xl'
          }`}>
            Allo Réparateur
          </div>
        )}
      </div>
    </div>
  );
}